import requestCommon from "@/components/web-interface/requestCommon";
const state = {
    variationData: null,
    instruments: null,
    feeder: null,
    loginFailedUsers: null,
    amountInvested: null,
    pnl: null,
    indexTick:null,
};
const actions = {
    getStatusVariation(context, data) {
        return requestCommon.getInfo(
            "status/system-variation",
            null,
            null,
            context,
            "getVariationDataSuccessHandler",
            "getVariationDataErrorHandler"
        );
    },
    getInstrumentsCount(context, data) {
        return requestCommon.getInfo(
            "status/instrument-count",
            null,
            null,
            context,
            "getInstrumentsDataSuccessHandler",
            "getInstrumentsDataErrorHandler"
        );
    },
    getFeederStatus(context, data) {
        return requestCommon.getInfo(
            "status/feeder",
            null,
            null,
            context,
            "getFeederDataSuccessHandler",
            "getFeederDataErrorHandler"
        );
    },
    getUserLoginFailedCount(context, data) {
        return requestCommon.getInfo(
            "status/no-session",
            null,
            null,
            context,
            "getUserLoginDataSuccessHandler",
            "getUserLoginDataErrorHandler"
        );
    },
    getAmountInvested(context, data) {
        return requestCommon.getInfo(
            "status/amount-invested",
            null,
            null,
            context,
            "getAmountInvestedSuccessHandler",
            "getAmountInvestedErrorHandler"
        );
    },
    getPnl(context, data) {
        return requestCommon.getInfo(
            "status/pnl",
            null,
            null,
            context,
            "getPnlSuccessHandler",
            "getPnlErrorHandler"
        );
    },
    getIndexTick(context, data) {
        return requestCommon.getInfo(
            "status/index-tick",
            null,
            null,
            context,
            "getIndexTickSuccessHandler",
            "getIndexTickErrorHandler"
        );
    },
}
const mutations = {
    getVariationDataSuccessHandler(state, data) {
        state.variationData = data.server.data;
    },
    getVariationDataErrorHandler(context, error,) {
        console.log(error);
    },
    getInstrumentsDataSuccessHandler(state, data) {
        state.instruments = data.server.data;
    },
    getInstrumentsDataErrorHandler(context, error,) {
        console.log(error);
    },
    getFeederDataSuccessHandler(state, data) {
        state.feeder = data.server.data;
    },
    getFeederDataErrorHandler(context, error,) {
        console.log(error);
    },
    getUserLoginDataSuccessHandler(state, data) {
        state.loginFailedUsers = data.server.data;
    },
    getUserLoginDataErrorHandler(context, error,) {
        console.log(error);
    },
    getAmountInvestedSuccessHandler(state, data) {
        state.amountInvested = data.server.data;
    },
    getAmountInvestedErrorHandler(context, error,) {
        console.log(error);
    },
    getPnlSuccessHandler(state, data) {
        state.pnl = data.server.data;
    },
    getPnlErrorHandler(context, error,) {
        console.log(error);
    },
    getIndexTickSuccessHandler(state, data) {
        state.indexTick = data.server.data;
    },
    getIndexTickErrorHandler(context, error,) {
        console.log(error);
    },
};
const getters = {};
export const statusDashboard = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
